import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:{
      userId:"",
      userName:"",
      administrator:false,
      totp:false,
      ecAdmin:false,
      proxyUserKey:""
    },
    systemMessege:{
      color:"red",
      text:"",
      timeout:1500,
    },
    api:{
      sessionId:"",
    },
    apiSaver:{
      connection:false,
      apiRequest:null,
    },
  },
  mutations: {
    setUser(state,user){
      state.user.userId = user.userId;
      state.user.userName = user.userName;
      state.user.administrator = user.administrator?true:false;
      state.user.totp = user.totp?true:false;
      state.user.ecAdmin = user.ecAdmin?true:false;
      state.user.proxyUserKey = user.proxyUserKey;
    },
    setSysMessege(state,systemMessege){
      state.systemMessege.color = systemMessege.color;
      state.systemMessege.text = systemMessege.text;
      state.systemMessege.timeout = systemMessege.timeout;
    },
    api(state,api){
      if(api.sessionId){
        state.api = api.sessionId;
      }
    },
    setApiSaver(state,apiSaver){
      state.apiSaver.connection  = apiSaver.connection;
      state.apiSaver.apiRequest  = apiSaver.apiRequest;
    },
  },
  actions: {
  },
  modules: {
  }
})
